const customerInfos = window.isEnvDevelopment ? {
  gender: '1',
  last_name: window.account?.last_name || 'test',
  first_name: window.account?.first_name || 'test',
  birthdate: '1999-11-12',
  email: window.account?.email || 'test@gmail.com',
  mobile_phone_number: '0600000000',
  phone_number: '',
  company_name: '',
  company_siren: '',
  address: 'aa',
  postal_code: '84250',
  country_code: 'FR',
  city: 'LE THOR'
} : {
  gender: '',
  last_name: window.account?.last_name || '',
  first_name: window.account?.first_name || '',
  birthdate: '',
  email: window.account?.email || '',
  mobile_phone_number: '',
  phone_number: '',
  company_name: '',
  company_siren: '',
  address: '',
  postal_code: '',
  country_code: '',
  city: ''
}

export default {
  customer_infos: { ...customerInfos },
  contractor_infos: { ...customerInfos },

  customerTemplateObject: {
    gender: '',
    last_name: '',
    first_name: '',
    birthdate: '',
    email: '',
    mobile_phone_number: '',
    phone_number: '',
    company_name: '',
    company_siren: '',
    address: '',
    address_reformed: [],
    postal_code: '',
    country_code: '',
    city: ''
  },

  genders: {
    1: 'Mr.',
    2: 'Mme.'
  },

  cities: null
}
